import { GroupPicker } from '@work4all/components/lib/components/entity-picker/GroupPicker';
import { useSalesOpportunityGroups } from '@work4all/components/lib/components/entity-picker/sales-opportunities-group-picker/useSalesOpportunityGroups';

import { Group } from '@work4all/models/lib/Classes/Group.entity';
import { SalesOpportunityGroup } from '@work4all/models/lib/Classes/SalesOpportunityGroup.entity';

export interface SalesOpportunitiesGroupPickerProps {
  value: Group | Group[] | null;
  onChange: (value: SalesOpportunityGroup[]) => void;
  multiple?: boolean;
}

export function SalesOpportunitiesGroupPicker(
  props: SalesOpportunitiesGroupPickerProps
) {
  const { value, onChange, multiple } = props;

  const response = useSalesOpportunityGroups();
  const groups =
    response.data?.map((item) => ({
      name: item.name,
      id: item.id,
      index: item.index,
      parentId: item.parentCode,
    })) ?? null;

  return (
    <GroupPicker
      {...props}
      value={
        Array.isArray(value)
          ? value?.map((item) => ({ ...item, parentId: 0 }))
          : [{ ...value, parentId: 0 }]
      }
      onChange={(e) => {
        onChange(e.map((item) => ({ name: item.name, id: item.id })));
      }}
      groups={groups}
      multiple={multiple}
    />
  );
}
